import { KidProfile, Task, Progress } from '../types';

export const mockKidProfile: KidProfile = {
  name: "Ari",
  theme: "defaultHighContrast",
  clockMode: "analog",
  locale24h: true
};

interface ProfileWithTasks {
    id: string;
    profileId: string;
    displayName: string;
    tasks: Task[];
    fadePastDueMinutes: number;
    previewWindowMinutes: number;
}

// Sophie's profile data
export const sophieProfileData: ProfileWithTasks = {
  id: "sophie-school-day",
  profileId: "profile-sophie",
  displayName: "Sophie",
  tasks: [
    // Morning Routine
    {
      id: "wake-up",
      profileId: "profile-sophie",
      label: "Wake Up",
      icon: "☀️",
      color: "#FFB020",
      start: "07:00",
      end: "07:30",
    },
    {
      id: "get-ready",
      profileId: "profile-sophie",
      label: "Get Ready",
      icon: "👕",
      color: "#7C5CFF",
      start: "07:30",
      end: "08:00",
    },
    {
      id: "leave-school",
      profileId: "profile-sophie",
      label: "Leave for School",
      icon: "🎒",
      color: "#34D399",
      start: "08:00",
      end: "08:15",
    },
    
    // After School
    {
      id: "homework",
      profileId: "profile-sophie",
      label: "Homework",
      icon: "📚",
      color: "#5DADE2",
      start: "16:00",
      end: "17:00",
    },
    {
      id: "dinner",
      profileId: "profile-sophie",
      label: "Dinner",
      icon: "🍽️",
      color: "#FF6B9D",
      start: "18:00",
      end: "18:45",
    },
    {
      id: "bed-prep",
      profileId: "profile-sophie",
      label: "Get Ready for Bed",
      icon: "🌙",
      color: "#818CF8",
      start: "19:30",
      end: "20:00",
    }
  ],
  fadePastDueMinutes: 20,
  previewWindowMinutes: 60
};

// Valerie's profile data
export const valerieProfileData: ProfileWithTasks = {
  id: "valerie-work-day",
  profileId: "profile-valerie",
  displayName: "Valerie",
  tasks: [
    // Morning
    {
      id: "wake-up-parent",
      profileId: "profile-valerie",
      label: "Wake Up",
      icon: "☕",
      color: "#FFB020",
      start: "06:30",
      end: "07:00",
    },
    {
      id: "morning-routine-parent",
      profileId: "profile-valerie",
      label: "Morning Routine",
      icon: "📝",
      color: "#5DADE2",
      start: "07:00",
      end: "08:00",
    },
    {
      id: "school-run",
      profileId: "profile-valerie",
      label: "School Run",
      icon: "🚗",
      color: "#34D399",
      start: "08:00",
      end: "08:30",
    },

    // Evening
    {
      id: "prep-dinner",
      profileId: "profile-valerie",
      label: "Prepare Dinner",
      icon: "👨‍🍳",
      color: "#FFB020",
      start: "17:30",
      end: "18:00",
    },
    {
      id: "family-dinner",
      profileId: "profile-valerie",
      label: "Dinner",
      icon: "🍽️",
      color: "#FF6B9D",
      start: "18:00",
      end: "18:45",
    },
    {
      id: "bed-prep-parent",
      profileId: "profile-valerie",
      label: "Bed Prep",
      icon: "🛁",
      color: "#7C5CFF",
      start: "19:30",
      end: "20:00",
    }
  ],
  fadePastDueMinutes: 20,
  previewWindowMinutes: 60
};

export const mockProgress: Progress = {
  date: "2026-10-14",
  completedTaskIds: []
};
